import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["href", "onClick"],
  _excluded2 = ["children"];
import React, { forwardRef } from 'react';
import Avatar from '@atlaskit/avatar';
import mergeRefs from '@atlaskit/ds-lib/merge-refs';
import { ButtonItem, CustomItem, LinkItem } from '@atlaskit/menu';
import useRegisterItemWithFocusManager from './internal/hooks/use-register-item-with-focus-manager';
var AvatarGroupItem = /*#__PURE__*/forwardRef(function (props, ref) {
  var avatar = props.avatar,
    onAvatarClick = props.onAvatarClick,
    testId = props.testId,
    index = props.index;
  var href = avatar.href,
    onClick = avatar.onClick,
    rest = _objectWithoutProperties(avatar, _excluded);
  var itemRef = useRegisterItemWithFocusManager();
  var CustomComponent = function CustomComponent(_ref) {
    var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded2);
    return (
      /*#__PURE__*/
      // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
      React.createElement("button", _extends({
        type: "button"
      }, props), children)
    );
  };
  var AvatarIcon = /*#__PURE__*/React.createElement(Avatar, _extends({}, rest, {
    testId: testId && "".concat(testId, "--avatar"),
    borderColor: "transparent",
    size: "small",
    name: ""
  }));

  // onClick handler provided with avatar data takes precedence, same as with the normal avatar item
  var callback = onClick || onAvatarClick;
  if (href) {
    return /*#__PURE__*/React.createElement(LinkItem, {
      ref: mergeRefs([ref, itemRef]),
      href: href,
      target: avatar.target,
      rel: avatar.target === '_blank' ? 'noopener noreferrer' : undefined,
      iconBefore: AvatarIcon,
      testId: testId,
      onClick: function onClick(event) {
        return callback && callback(event, undefined, index);
      }
    }, avatar.name);
  }
  if (typeof callback === 'function') {
    return /*#__PURE__*/React.createElement(ButtonItem, {
      ref: mergeRefs([ref, itemRef]),
      onClick: function onClick(event) {
        return callback && callback(event, undefined, index);
      },
      iconBefore: AvatarIcon,
      testId: testId
    }, avatar.name);
  }
  return /*#__PURE__*/React.createElement(CustomItem, {
    iconBefore: AvatarIcon,
    component: CustomComponent,
    testId: testId
  }, avatar.name);
});

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default AvatarGroupItem;